module.exports = __webpack_public_path__ + "img/Logo ITP.bf494b45.svg";